import React from 'react';
import Mousetrap from 'mousetrap';
import parseHeader from 'parse-link-header';

import Snackbar from 'material-ui/Snackbar';

import MainAppBar from '../components/MainAppBar/MainAppBar';
import AppDrawer from '../components/AppDrawer';
import TagsPopup from '../components/TagsPopup';
import NextButton from '../components/NextButton';
import MasonryFeed from '../components/MasonryFeed';
import AddMoleculePopup from '../components/AddMoleculePopup';
import '../components/AppDrawer.css';

import StashAPI from '../StashAPI';
import pckg from '../../package.json';
import './FeedPage.css';


export default class FeedPage extends React.Component {

  constructor() {
    super();
    const parsedUrl = new URL(window.location.href);
    const authToken = parsedUrl.searchParams.get('authToken');
    console.log('authToken', authToken);
    if (authToken) {
        (new StashAPI()).setAuthToken(authToken);
        window.location = '/';
    }
    const feeds = [{
      name: 'latest',
      label: 'Latest fisrt',
      description: 'You are on the \'Latest first\' feed',
      actions: [{
        name: 'open-molecule',
        label: 'Open',
        description: 'Open details page',
        icon: 'open',
      }, {
        name: 'delete-molecule',
        label: 'Delete',
        description: 'Delete molecule',
        icon: 'trash',
      }, {
        name: 'open-original',
        label: 'Original',
        description: 'Open original link in new tab',
        icon: 'original',
      }, {
        name: 'edit-tags',
        label: 'Tags',
        description: 'Edit tags on this molecule',
        icon: 'editTags',
      }]
    }, {
      name: 'trash',
      label: 'Trash',
      description: 'Only deleted molecules are shown!',
      actions: [{
        name: 'restore-molecule',
        label: 'Restore',
        description: 'Restore deleted molecule',
        icon: 'restore',
      }, {
        name: 'purge-molecule',
        label: 'Purge',
        description: 'Delete forever',
        icon: 'purge',
      }],
    }];
    this.state = {
      snackOpen: false,
      snackMessage: '',
      addPopupOpen: false,
      tagsPopupOpen: false,
      molecules: [],
      selected: [],
      moleculeTags: [],
      existingTags: [],
      selectedMoleculeToTag: null,
      loadingFeed: false,
      next: null,
      feeds: feeds,
      feed: feeds[0],
      isSearchActive: false,
    };
  }

  newMoleculesShortcut = () => {
    this.setState({addPopupOpen: true});
  }

  clearSelected = () => {
    this.setState({selected: []});
    this.setState({isSearchActive: false});
  }

  componentDidMount() {
    Mousetrap.bind(['ctrl+m'], this.newMoleculesShortcut);
    Mousetrap.bind(['esc'], this.clearSelected);
  }

  componentWillUnmount() {
    Mousetrap.unbind(['ctrl+m'], this.newMoleculesShortcut);
    Mousetrap.unbind(['esc'], this.clearSelected);
  }

  addMolecule(moleculeType, data) {
    return (new StashAPI()).createMolecule(moleculeType, data)
    .then(response => {
      const { molecules } = this.state;
      const { fp } = response.data;
      this.setState({
        molecules: [{
          type: 'root',
          fp: fp,
        }, ...molecules, ],
      });
      this.getFeedItem(fp);
    }).catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  deleteMolecule(fp) {
    return (new StashAPI()).deleteMolecule(fp).then(response => {
      const bkpMolecules = this.state.molecules;
      const molecules = [];
      for (let molecule of this.state.molecules) {
        if (molecule.fp !== fp) {
          molecules.push(molecule);
        }
      }
      this.setState({
        molecules: molecules,
        dynamicContent: (
          <Snackbar
            open={true}
            message="Molecule has been deleted!"
            action="undo"
            autoHideDuration={4000}
            onRequestClose={() => {
              this.setState({dynamicContent: null});
            }}
            onActionTouchTap={e => {
              this.restoreMolecule(fp).then(response => {
                this.setState({
                  dynamicContent: null,
                  molecules: bkpMolecules,
                });
              });
            }}
          />
        ),
      });
    }).catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  purgeMolecule(fp) {
    const { molecules: oldMolecules } = this.state;
    return (new StashAPI()).deleteMolecule(fp, true).then(response => {
      const molecules = [];
      for (let molecule of oldMolecules) {
        if (molecule.fp !== fp) {
          molecules.push(molecule);
        }
      }
      this.setState({molecules: molecules});
    }).catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  restoreMolecule(fp) {
    const { molecules: oldMolecules } = this.state;
    return (new StashAPI()).restoreMolecule(fp).then(response => {
      const molecules = [];
      for (let molecule of oldMolecules) {
        if (molecule.fp !== fp) {
          molecules.push(molecule);
        }
      }
      this.setState({molecules: molecules});
    }).catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  editTags(molecule) {
    return (new StashAPI()).getTagsForMolecule(molecule.fp).then(response => {
      const tags = [];
      for(let tag of response.data) {
        tags.push({
          'fp': tag.fp,
          'name': tag.content,
        });
      }
      this.setState({
        tagsPopupOpen: true,
        tagsPopupError: '',
        selectedMoleculeToTag: molecule,
        existingTags: tags,
      });
    }).catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  addTagOnMolecule(molecule, tagName) {
    return (new StashAPI()).createTagOnMolecule(
      molecule.fp, tagName
    ).then(response => {
      console.log('addTagOnMolecule', response);
    }).catch(error => {
      const { status, data} = error.response;
      if (status === 400 && data.error === 'Invalid tag name length') {
        const { min_length, max_length } = data;
        this.setState({
          tagsPopupError: `Tag name must be between ${min_length} and ${
            max_length} characters long.`,
        });
        return;
      }
      console.log(error);
      return Promise.reject(error);
    });
  }

  removeTagOnMolecule(molecule, tag) {
    return (new StashAPI()).removeTagOnMolecule(
      molecule.fp, tag.fp
    ).then(response => {
      console.log('removeTagOnMolecule', response);
    }).catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  getFeedItem(fp) {
    (new StashAPI()).getMoleculeDetails(fp).then(response => {
      const molecule = response.data;
      // TODO: check is this thread safe?
      const { molecules } = this.state;
      for (let i = 0; i < molecules.length; i++) {
        if (molecules[i].fp === molecule.fp) {
          let oldMolecule = molecules[i];
          molecule.created_at = oldMolecule.created_at;
          molecule.modified_at = oldMolecule.modified_at;
          molecules[i] = molecule;
          break;
        }
      }
      const existingTags = [];
      for (let atom of molecule.atoms) {
        if (atom.type === 'tag') {
          existingTags.push({fp: atom.fp, name: atom.content});
        }
      }
      this.setState({molecules: molecules, existingTags: existingTags});
    }).catch(error => {
      console.log(error);
    });
  }

  updateSuggestedTags(searchTerm) {
    (new StashAPI()).getSuggestedTags(searchTerm).then(response => {
      console.log('response.data', response.data);
      this.setState({'moleculeTags': response.data.map((tag, index) => {
        return {fp: tag.fp, name: tag.content};
      })});
    });
  }

  loadFeedItems(promise, clear=false) {
    this.setState(state => {
      state.loadingFeed = true;
      if (clear) {
        state.molecules = [];
      }
    }, () => {
      promise.then(response => {
        const newItems = response.data;
        const { molecules } = this.state;
        // first set fingerprints so we have correct order in results
        for (let molecule of newItems) {
          molecules.push(molecule);
        }
        const links = parseHeader(response.headers.link) || {};
        this.setState((state) => {
          state.loadingFeed = false;
          state.molecules = molecules;
          state.next = links.next;
        }, () => {
          // update only new items!
          for (const item of newItems) {
            this.getFeedItem(item.fp);
          }
        });
      }).catch(error => {
        // TODO: popup with message 'Need to login' with 3s timeout
        // without any option
        this.setState({loadingFeed: false});
        const { loginPage } = pckg;
        if (loginPage && error.response && error.response.status === 401) {
          window.location = loginPage;
        }
        console.log(error);
      });
    });
  }

  componentWillMount() {
    const { feed } = this.state;
    this.setState({
      molecules: [],
      loadingFeed: false,
      next: null,
    });
    this.loadFeedItems((new StashAPI()).getMolecules(feed.name));
  }

  moleculeAction(action, payload) {
    const { name: action_id, } = action;
    const { molecule, url } = payload;
    if (action_id === 'open-original') {
      window.open(url, '_blank').focus();
    } else if (action_id === 'delete-molecule') {
      this.deleteMolecule(molecule.fp);
    } else if (action_id === 'purge-molecule') {
      this.purgeMolecule(molecule.fp);
    } else if (action_id === 'restore-molecule') {
      this.restoreMolecule(molecule.fp);
    } else if (action_id === 'edit-tags') {
      this.editTags(molecule);
    } else {
      console.log('Un-handled action', action, payload);
    }
  }

  render() {
    const {
      molecules,
      selected,
      loadingFeed,
      next,
      drawerOpen,
      feed,
      dynamicContent,
      isSearchActive,
    } = this.state;
    const actions = (feed && feed.actions) ? feed.actions : [];
    let layout = selected.length > 0 ? 'selected': 'inactive';
    if (isSearchActive) {
      layout = 'search';
    }
    return (
      <div
        className="Feed"
        onTouchTap={e => {
          this.clearSelected();
        }}
      >
        <div>
{/*          <InfoBar
            onSearch={(searchTerm) => {
              this.loadFeedItems(
                (new StashAPI()).searchMolecules(searchTerm), true
              );
            }}
            onAdd={() => {
              this.setState({addPopupOpen: true});
            }}
            onExpand={() => {
              this.setState({drawerOpen: true});
            }}
          />*/}
          <MainAppBar
            layout={layout}
            actions={actions}
            selected={selected}
            feed={feed}
            onAction={p => {
              /*console.log(p);*/
            }}
            onMainAppBarInactiveSideBar={p => {
              this.setState({drawerOpen: true});
            }}
            onMainAppBarInactiveAddNew={p => {
              this.setState({addPopupOpen: true});
            }}
            onMainAppBarInactiveSearch={p => {
              this.setState({isSearchActive: true});
            }}
            onMainAppBarSearchClose={p => {
              this.setState({isSearchActive: false});
            }}
            onMainAppBarSelectedClear={p => {
              this.clearSelected();
            }}
            onMainAppBarSearchSearch={p => {
              this.loadFeedItems(
                (new StashAPI()).searchMolecules(p.value), true
              );
            }}
            onMainAppBarSelectedAction={p => {
              for(let molecule of selected) {
                switch(p.actionName) {
                  case 'edit-tags':
                    this.editTags(molecule);
                    break;
                  case 'open-molecule':
                    console.log('open molecule', p);
                    break;
                  case 'delete-molecule':
                    this.deleteMolecule(molecule.fp);
                    break;
                  case 'purge-molecule':
                    this.purgeMolecule(molecule.fp);
                    break;
                  case 'restore-molecule':
                    this.restoreMolecule(molecule.fp);
                    break;
                  case 'open-original':
                    let url = '';
                    for (let atom of molecule.atoms) {
                      if (atom.type === 'url') {
                        url = atom.content;
                      }
                    }
                    if (url) {
                      window.open(url, '_blank');
                    }
                    break;
                  default:
                    console.log('Un-handled action', p);
                    break;
                }
              }
            }}
          />
          <div style={{marginTop: 50}}>
            <MasonryFeed
              molecules={molecules}
              selected={selected}
              actions={actions}
              fireAction={(a, p) => {
                this.moleculeAction(a, p);
              }}
              onAction={action => {
                console.log('action:', JSON.stringify({
                  name: action.name,
                  target: action.target,
                  molecule: action.molecule.fp,
                }));
              }}
              onClick={action => {
                const { molecule } = action;
                this.setState(state => {
                  const { selected } = state;
                  if (selected.indexOf(molecule) !== -1) {
                    selected.splice(selected.indexOf(molecule), 1);
                  } else {
                    state.selected.push(molecule);
                  }
                }, () => {
                  setTimeout(() => {
                    this.setState(this.state);
                  }, 10);
                });
              }}
            />
            <NextButton
              style={{marginBottom: 5}}
              next={next}
              loading={loadingFeed}
              onTouchTap={(e) => {
                const { next } = this.state;
                const { q, feed, limit, offset, tags } = next;
                let ptags = [];
                if (tags) {
                  ptags = JSON.parse(tags);
                }
                // we need to parse tags, since it is an string in 'next'
                this.loadFeedItems((new StashAPI()).getMolecules(
                  feed, limit, offset, ptags, q
                ));
              }}
            />
          </div>
        </div>
        <AddMoleculePopup
          open={this.state.addPopupOpen}
          onAdd={(molecule, data) => {
            this.setState({addPopupOpen: false});
            this.addMolecule(molecule.type, data);
          }}
          onCancel={(data) => {
            this.setState({addPopupOpen: false});
            console.log('New molecule canceled', data);
          }}
        />
        <TagsPopup
          open={this.state.tagsPopupOpen}
          tags={this.state.moleculeTags}
          existingTags={this.state.existingTags}
          molecule={this.state.selectedMoleculeToTag}
          tagsPopupError={this.state.tagsPopupError}
          getTags={(q, molecule) => {
            if (q.length > 1) {
              this.updateSuggestedTags(q);
            }
          }}
          addTag={(tagName, molecule) => {
            this.addTagOnMolecule(molecule, tagName).then(() => {
              this.setState({tagsPopupError: ''});
              this.getFeedItem(molecule.fp);
            });
          }}
          removeTag={(tag, molecule) => {
            this.removeTagOnMolecule(molecule, tag).then(() => {
              this.setState({tagsPopupError: ''});
              this.getFeedItem(molecule.fp);
            });
          }}
          onCancel={() => {
            console.log('Tags popup closed');
            this.setState({tagsPopupOpen: false});
          }
        }
        />
        <AppDrawer
          open={drawerOpen}
          onRequestChange={(open) => {
            this.setState({drawerOpen: open});
          }}
          feed={feed.name}
          selectFeed={(feedName) => {
            this.setState(state => {
              state.drawerOpen = false;
              state.molecules = [];
              state.loadingFeed = false;
              state.next = null;
              for(let feed of state.feeds) {
                if(feed.name === feedName) {
                  state.feed = feed;
                  state.selected = [];
                }
              }
            }, () => {
              const { feed } = this.state;
              this.loadFeedItems((new StashAPI()).getMolecules(feed.name));
            });
          }}
        />
        {dynamicContent}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/FeedPage.jsx